<template>
    <div class="text-center mx-auto">
        <h3>Loading data... Please wait</h3>
        <p>We are retrieving the latest data from our servers</p>
    </div>
</template>